import { z } from 'zod'

/**
 * Misc category domain model
 * Represents a user-defined sub-category for miscellaneous job costs
 */
export const MiscCategorySchema = z.object({
  miscCategoryGuid: z.string().uuid(),
  companyGuid: z.string().uuid(),
  name: z.string().min(1).max(50),
  isActive: z.boolean(),
  createdByUserGuid: z.string().uuid(),
  lastEditedByUserGuid: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type MiscCategory = z.infer<typeof MiscCategorySchema>

/**
 * Type guard for MiscCategory
 */
export function isMiscCategory(value: unknown): value is MiscCategory {
  return MiscCategorySchema.safeParse(value).success
}
